import { FlexSpacer } from 'ui/flexSpacer';
import { Body2 } from 'ui/theme';
import { BausControlsDropdown } from './BausControlsDropdown';
import { BillingDateRangePicker } from './BillingDateRangePicker';

export const BillingPagePageActions = () => {
  return (
    <FlexSpacer flexDirection="column" alignItems="stretch">
      <BausControlsDropdown />
      <FlexSpacer justifyContent="flex-end" alignItems="baseline">
        <Body2>Viewing metrics recorded&nbsp;&nbsp;</Body2>
        <BillingDateRangePicker />
      </FlexSpacer>
    </FlexSpacer>
  );
};
